import React, {useEffect, useState} from 'react';
import ProfileImage from "../../../components/Profile/ProfileImage";
import ProfileField from "../../../components/Profile/ProfileField";
import ProfileTextBox from "../../../components/Profile/ProfileTextBox";
import Button from "../../../components/Button";
import {StatusBadge, UserCode, Heading, Heading2} from "../../../components/Profile/ProfileComponents";
import {useNavigate, useParams} from "react-router-dom";
import api from "../../../api";
import {toPersianNumbers} from "../../../utils/toPersianNumbers";
import {miladiToShamsi} from "../../../utils/miladiToShamsi";

export default function DriverProfileAdmin() {
  const {id}=useParams();
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const fetchProfile = async () => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      navigate("/user-login/");
      return;
    }

    if (!id) {
      console.warn("No profile id provided in route params");
      navigate("/admin/users/");
      return;
    }

    try {
      const response = await api.get(
        `accounts/admin/driver/profile/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setProfile(response.data);
    } catch (error) {
      console.error("خطا در گرفتن پروفایل:", error);
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("accessToken");
        navigate("/user-login/");
      }
    }
  };

  fetchProfile();
}, [id, navigate]);

  if (!profile) return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg text-gray-600">در حال بارگذاری...</p>
    </div>
  );
  console.log("User data:", profile);

  return (
      <div className="p-6">

        {/* محتوای اصلی */}
          <div className="mb-8">


              {/* --- بخش بالای پروفایل --- */}
              <div className="flex flex-col md:flex-row items-start gap-6 mb-8 border-b border-gray-200 pb-8">
                  {/* عکس پروفایل */}
                  <ProfileImage src={profile.profile_picture}/>

                  {/* اطلاعات کناری عکس */}
                  <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                      {/* ستون ۱: نام و نام خانوادگی */}
                      <div>
                          <Heading title={profile.full_name} placeHolder={"نام و نام خانوادگی"}/>
                          <Heading2 title={profile.title} placeHolder={"توسعه دهنده بازارگاه کالاهای ساختمانی"}/>
                      </div>

                      {/* ستون ۲: وضعیت فعال بودن + کد مشتری */}
                      <div className="flex flex-col items-start sm:items-end gap-2">
                          <StatusBadge isActive={profile.user.is_active}/>
                          <UserCode label={'کد راننده'} code={toPersianNumbers(profile.driver_code)}/>

                      </div>
                  </div>
              </div>

              {/* --- باکس متن معرفی --- */}
              <Heading title={"معرفی"}/>
              <ProfileTextBox text={profile.description}/>

              {/* --- مشخصات کاربر --- */}
              <div className="mb-10">
                  <Heading title={"مشخصات شخصی"} placeHolder={"مشخصات شخصی"}/>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                      <ProfileField label="شرکت حمل" value={profile.carrier_company}/>
                      <ProfileField label="شماره پلاک" value={toPersianNumbers(profile.plate_number)}/>
                      <ProfileField label="کد ملی" value={toPersianNumbers(profile.national_id)}/>
                      <ProfileField label="تاریخ تولد" value={toPersianNumbers(miladiToShamsi(profile.birth_date))}/>
                      <ProfileField label="شماره موبایل دوم" value={toPersianNumbers(profile.secondary_phone)}/>
                      <ProfileField label="استان" value={profile.province}/>
                      <ProfileField label="شهر" value={profile.city}/>
                      <ProfileField
                          label="وضعیت احراز هویت"
                          value={profile.kyc_status === "verified" ? "تأیید شده" : "تأیید نشده"}
                      />
                  </div>
              </div>

              {/* --- دکمه‌های انتهایی --- */}
              <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
                  <Button children={'ویرایش'}
                          onClick={() => navigate(`/admin-panel/driver-user-management/${id}/edit`)}/>
                  <Button variant={'secondary'} children={'بازگشت'}
                          onClick={() => navigate("/admin-panel/driver-user-management/")}/>
              </div>
          </div>

      </div>

  );
}